<template>
	<div class="portlet-title">
    	<div class="caption text-success">{{line.titulopagina}}</div>
    </div>
</template>
<script>
	
	export default{
		data(){
			return{

			}
		},
		props:{
        	line: {}
    	}
	}
</script>


// WEBPACK FOOTER //
// titulopagina.vue?684ccf54